import {
  INBODY_INDICATORS_KEY,
  InbodyIndicatorsKey,
} from '../../../../../../constants/inbodyIndecatorsKey';

export type InbodyIndicatorGroup = {
  title: string;
  description: string;
  indicatorKeys: InbodyIndicatorsKey[];
};

const K = INBODY_INDICATORS_KEY;

export const INBODY_INDICATOR_GROUPS: InbodyIndicatorGroup[] = [
  {
    title: 'Quick Snapshot',
    description: "A fast view of the client's most important scan changes.",
    indicatorKeys: [K.WEIGHT, K.SMM, K.PBF, K.ECW_TBW],
  },
  {
    title: 'SWYMO Score',
    description:
      'A combined score showing how the client compares across key health markers.',
    indicatorKeys: [K.SMI, K.FMI, K.ECW_TBW, K.PHASE_ANGLE],
  },
  {
    title: 'Muscle Fat',
    description:
      'Tracks the balance between lean mass, body fat, and overall body composition.',
    indicatorKeys: [K.WEIGHT, K.SMM, K.PBF, K.BFM],
  },
  {
    title: 'Water',
    description:
      'Shows hydration status, fluid balance, and water distribution inside and outside the cells.',
    indicatorKeys: [K.TBW_WEIGHT, K.ICW, K.ECW, K.ECW_TBW],
  },
  {
    title: 'Obesity',
    description:
      'Tracks obesity-related markers, fat distribution, and risk-related progress over time.',
    indicatorKeys: [K.BMI, K.PBF, K.VFA, K.VFL],
  },
  {
    title: 'Metabolism',
    description:
      'Shows calorie demand, lean mass support, and energy-related changes from scan to scan.',
    indicatorKeys: [K.BMR, K.LBM, K.FFMI, K.PHASE_ANGLE],
  },
];
